import { render, staticRenderFns } from "./ResumePollsChart.vue?vue&type=template&id=4fd24c09"
import script from "./ResumePollsChart.vue?vue&type=script&lang=ts"
export * from "./ResumePollsChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports